// src/services/admin/NotificationManager.js
import axiosInstance from "../../utils/axiosInstance"; // Use your authenticated instance
import config from "../../config";

const BASE_URL = `/notification`; // already under /api/admin via axiosInstance

const NotificationManager = {
  /**
   * Send a broadcast notification to all users.
   */
  async sendBroadcast({ title, body, image = null, data = null }) {
    try {
      const msg = { recipientToken: null, title, body, image, data };
      const res = await axiosInstance.post(`${BASE_URL}/send`, msg);
      return res.data;
    } catch (err) {
      console.error("Error broadcasting notification:", err.response?.data || err.message);
      throw err;
    }
  },

  /**
   * Send a notification to a particular user.
   */
  async sendToUser({ userId, title, body, image = null, data = null }) {
    try {
      const req = { userId, title, body, image, data };
      const res = await axiosInstance.post(`${BASE_URL}/send-to-user`, req);
      return res.data;
    } catch (err) {
      console.error("Error sending to user:", err.response?.data || err.message);
      throw err;
    }
  },

  /**
 * Send a broadcast notification to a topic.
 */
  async sendToTopic({ topic = "all", title, body, image = null, data = null }) {
    try {
      const req = { topic, title, body, image, data };
      const res = await axiosInstance.post(`${BASE_URL}/broadcast`, req);
      return res.data;
    } catch (err) {
      console.error("Error sending to topic:", err.response?.data || err.message);
      throw err;
    }
  },


};

export default NotificationManager;
